import React from 'react';
import { Button } from '@mui/material';
import { MdEdit } from 'react-icons/md';

const CssEditButton = ({ onClick }) => {
  return (
    <Button
      variant="contained"
      startIcon={<MdEdit />}
      onClick={onClick}
      sx={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        background: 'linear-gradient(90deg, #1475E1, #5AABFF)',
        borderRadius: '8px',
        padding: '8px 15px',
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'none',
        boxShadow: '0 4px 12px rgba(20, 117, 225, 0.3)',
        zIndex: 1000,
        '&:hover': {
          background: 'linear-gradient(90deg, #0C63C9, #4A9AEE)',
          boxShadow: '0 4px 15px rgba(20, 117, 225, 0.5)',
        },
      }}
    >
      CSS Düzenle
    </Button>
  );
};

export default CssEditButton; 